import './annotations.scss';
import './color-picker/color-picker-control.scss';
import './annotations-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/index.js